<template>
    <select2 v-model="selected" :options="options"
             style="width:100%"
             placeholder="--- Tất cả ---"></select2>
    <!--<div style="padding-top: 7px">
        <div class="custom-control custom-radio">
            <input type="radio" name="syncUnitType" class="custom-control-input" value="0" v-model="selected" id="sync-unit-type-0">
            <label for="sync-unit-type-0" class="custom-control-label">Tất cả</label>
        </div>
        <div class="custom-control custom-radio">
            <input type="radio" name="syncUnitType" class="custom-control-input" value="1" v-model="selected" id="sync-unit-type-1">
            <label for="sync-unit-type-1" class="custom-control-label">Dữ liệu đơn vị tự đồng bộ</label>
        </div>
        <div class="custom-control custom-radio">
            <input type="radio" name="syncUnitType" class="custom-control-input" value="2" v-model="selected" id="sync-unit-type-2">
            <label for="sync-unit-type-2" class="custom-control-label">Dữ liệu được cấp trên đồng bộ</label>
        </div>
    </div>-->
</template>
<script>

    export default {
        name: 'SyncUnitType',
        props: ['value'],
        data() {
            return {
                selected: this.value,
                options: [
                    { id: 0, text: 'Tất cả' },
                    { id: 1, text: 'Đơn vị tự đồng bộ' },
                    { id: 2, text: 'Cấp trên đồng bộ' }
                ]
            }
        },
        mounted: function () {

        },
        watch: {
            selected() {
                this.$emit('input', this.selected)
            }
        }
    }
</script>

<style scoped>
</style>

